import { Button } from "@/components/ui/button"
import { IconMessage } from "@tabler/icons-react"
import React, { useEffect, useRef, useState } from "react"
import { SendCommentaire, ViewCommentaires } from "@/components/commentaire/index"
import LoadingBtn from '@/components/ui/loading-btn'
import PaginationControls from "../pagination/PaginationControl"
import { DrupalNode } from "next-drupal/dist/types"
import {useSession} from "next-auth/react";

const MAX_PER_PAGE = 10

const CommentairesWrapper = ({ article }: { article: DrupalNode }) => {

  const [isOpen, setOpen] = useState(false)
  const commentsRef = useRef<HTMLDivElement>(null)
  const [isCommentLoading, setCommentLoading] = useState(false)
  const [commentId, setCommentId] = useState<string>('')
  const [commentBody, setCommentBody] = useState<string>('')
  const [comments, setComments] = useState([])
  const [totalPages, setTotalPages] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const [paginatedComments, setPaginatedComments] = useState<any[]>([])
  const { status } = useSession()
  const handleClick = () => {
    setOpen(!isOpen)
  }

  const parseComment = (comment) => {
    return {
      created: new Date(parseInt(comment.created[0].value) * 1000).toISOString(),
      comment_body: comment.comment_body[0].value,
      subject: comment.subject[0].value,
      uuid: comment.uuid[0].value,
      url: `/comment/${comment.uuid[0].value}`,
      is_response: Boolean(comment.pid?.length),
      cid: comment.cid[0].value,
      children: comment.children ? comment.children.map(child => parseComment(child)) : [],
      author: {
        id: comment.author.uid[0].target_id,
        name: comment.author.uid[0].user_data.name,
        roles: comment.author.uid[0].user_data.roles,
        created: new Date(parseInt(comment.author.uid[0].user_data.created.value) * 1000).toISOString(),
        status: comment.author.uid[0].user_data.status
      }
    }
  }

  const getComments = async (id) => {
    try {
      setCommentLoading(true)
      const cacheBuster = `_=${Date.now()}`
      const response = await fetch(`/api/article-comments?id=${id}&${cacheBuster}`, {
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache',
          'Expires': '0',
          "X-No-Cache": "1",
          "X-Cache-Bypass": "1"
        }
      })
      const data = await response.json()
      const simplifiedComments = data.map(comment => parseComment(comment))
      setComments(simplifiedComments)
    } catch (error) {
      console.error('Failed to fetch comments:', error)
    } finally {
      setCommentLoading(false)
    }
  }

  const refreshComments = () => {
    if (article && article.id) {
      getComments(article.id)
    }
  }

  useEffect(() => {
    refreshComments()
  }, [article])

  useEffect(() => {
    const newTotalPages = Math.ceil(comments.length / MAX_PER_PAGE)
    const newPaginatedComments = comments.slice(
      (currentPage - 1) * MAX_PER_PAGE,
      currentPage * MAX_PER_PAGE
    )

    setTotalPages(newTotalPages)
    setPaginatedComments(newPaginatedComments)
  }, [comments, currentPage])

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage)
    if (commentsRef.current) {
      commentsRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    }
  }

  return (
    <div>
      {status === "authenticated" ?
        <>
      {!isOpen || isCommentLoading ? (
        <div className={"flex justify-center"}>
          <LoadingBtn
            loading={isCommentLoading && isOpen}
            onClick={handleClick}
            variant={"secondary"}>
            <IconMessage className={"mr-2"} />Voir les commentaires
          </LoadingBtn>
        </div>
      ) : (
        <div className={"flex justify-center flex-col"}>
          <div className={"flex justify-center"}>
            <Button variant={"secondary"} onClick={handleClick}><IconMessage className={"mr-2"} />Fermer les commentaires</Button>
          </div>
          <div ref={commentsRef}>
            <SendCommentaire
              commentId={commentId}
              articleId={article.drupal_internal__nid}
              commentBody={commentBody}
              setCommentId={setCommentId}
              setCommentBody={setCommentBody}
              refreshComments={refreshComments}
            />
            <ViewCommentaires
              comments={paginatedComments}
              commentId={commentId}
              articleId={article.drupal_internal__nid}
              commentBody={commentBody}
              setCommentId={setCommentId}
              setCommentBody={setCommentBody}
              refreshComments={refreshComments}
            />
            <PaginationControls
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
      )}
        </>
        :
        <></>
      }
    </div>
  )
}

export default CommentairesWrapper
